import type { ReactNode } from "react";
import { FaInbox } from "react-icons/fa";

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export const EmptyState = ({
  title = "Chưa có dữ liệu",
  description,
  icon,
  action,
  className = "",
}: EmptyStateProps) => {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center py-12 px-5 ${className}`}
    >
      <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center text-3xl text-gray-400 mb-3">
        {icon ?? <FaInbox />}
      </div>
      <p className="text-base font-medium text-gray-700">{title}</p>
      {description && (
        <p className="text-sm text-gray-500 mt-1 max-w-sm">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};
